import { render, staticRenderFns } from "./PaymentLinkPage.vue?vue&type=template&id=4e4cdfea&scoped=true&"
import script from "./PaymentLinkPage.vue?vue&type=script&lang=ts&"
export * from "./PaymentLinkPage.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentLinkPage.vue?vue&type=style&index=0&id=4e4cdfea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4cdfea",
  null
  
)

export default component.exports